export default __webpack_public_path__ + "static/media/banner.ec7342ca.jpeg";